import { render, staticRenderFns } from "./blacklisted-candidate.vue?vue&type=template&id=3c89e1ee"
import script from "./blacklisted-candidate.vue?vue&type=script&lang=js"
export * from "./blacklisted-candidate.vue?vue&type=script&lang=js"
import style0 from "./blacklisted-candidate.vue?vue&type=style&index=0&id=3c89e1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports